/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvouchervaliddays3Inputs */

const en_dropvouchervaliddays3 = /** @type {(inputs: Dropvouchervaliddays3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher valid (days)`)
};

const de_dropvouchervaliddays3 = /** @type {(inputs: Dropvouchervaliddays3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gutschein gültig (Tage)`)
};

/**
* | output |
* | --- |
* | "Voucher valid (days)" |
*
* @param {Dropvouchervaliddays3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvouchervaliddays3 = /** @type {((inputs?: Dropvouchervaliddays3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvouchervaliddays3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvouchervaliddays3(inputs)
	return de_dropvouchervaliddays3(inputs)
});
export { dropvouchervaliddays3 as "dropVoucherValidDays" }